module.exports = __webpack_public_path__ + "img/noData.f3a0822c.png";